export const INITIAL_STATE = {
    activeTab: 1,
    documentTypes: [],
    documents: [],
    searchForm: {
      types: [],
      fields: [],
      selected: null,
      form: null
    },
    pagination: {
      currentPageNo: 0,
      pageCount: 0  
    }
  }
